import { DateTime } from "luxon";
import { classes } from "polytype";
import { DataModel, ReferenceModel } from "../../base";
import { config } from "../../config/config.js";
import { provideReact } from "../../react";
import type { SupportCodeData } from "./types.js";

export class SupportCode extends ReferenceModel {
  public static get = provideReact(async () => {
    const data = await config.behaviors.supportCode.get();
    return new SupportCodeDetailed(data);
  });
}

class SupportCodeCommon extends classes(
  DataModel<SupportCodeData>,
  SupportCode,
) {
  public readonly supportCode: string;
  public readonly expiresAt: DateTime;

  public constructor(data: SupportCodeData) {
    super([data], ["static"]);
    this.supportCode = data.supportCode;
    this.expiresAt = DateTime.fromISO(data.expiresAt);
    const timeoutDuration = this.expiresAt.diffNow();

    setTimeout(() => {
      SupportCode.get.asResource().refresh();
    }, timeoutDuration.milliseconds);
  }
}

export class SupportCodeDetailed extends classes(
  SupportCodeCommon,
  DataModel<SupportCodeData>,
) {
  public constructor(data: SupportCodeData) {
    super([data], [data]);
  }
}
